<template>
  <header
      class="nav__wrapper"
      :class="$store.state.scrollY > 50 && $store.state.scrollDirection !== 'up' ? 'active' : ''"
  >
    <nav>
      <logo class="lg:block hidden"/>
      <ul class="list-wrapper lg:flex hidden">
        <li class="item hidden">
          <a target="_blank" href="https://market.metarising.io">NFT Marketplace</a>
        </li>
        <li class="item hidden">
          <a target="_blank" href="https://market.metarising.io/map">Land Map</a>
        </li>
        <li class="item">
          <a target="_blank" href="https://seed-box.io">SeedBox</a>
        </li>
        <li class="item hidden">
          <a target="_blank" href="https://market.metarising.io/swap">Swap</a>
        </li>
        <li class="item">
          <a target="_blank" href="https://bridge.microtuber.io">Bridge</a>
        </li>
        <li class="item">
          <a target="_blank" href="https://metarising.gitbook.io/metarising-en-litepaper-version-1.0/"
             v-if="currentLang === 'en'"
          >Docs</a>
          <a target="_blank" href="https://metarising.gitbook.io/metarising-kr-litepaper-version-1.0/"
             v-else
          >Docs</a>
        </li>
      </ul>

      <!--  select lang / desk       -->
      <ul class="lang hidden lg:flex">
        <li class="lang-list"
            @click="currentLang = 'ko'"
            :class="currentLang === 'ko' ? 'clicked' : ''"
        >
          KR
        </li>
        <div class="line"></div>
        <li class="lang-list"
            @click="currentLang = 'en'"
            :class="currentLang === 'en' ? 'clicked' : ''"
        >
          EN
        </li>
      </ul>

      <!--  mobile nav    -->
      <div class="blex-between flex-no-wrap w-full px-16 lg:hidden flex">
        <logo/>
        <div class="blex">

          <!--  select lang / m       -->
          <div class="lang flex lg:hidden">
            <div class="lang-list"
                 @click="currentLang = 'ko'"
                 :class="currentLang === 'ko' ? 'clicked' : ''"
            >
              KR
            </div>
            <div class="line"></div>
            <div class="lang-list"
                 @click="currentLang = 'en'"
                 :class="currentLang === 'en' ? 'clicked' : ''"
            >
              EN
            </div>
          </div>

          <!--  menu icon        -->
          <div class="blex pl-24"
               @click="isClicked = true">
            <img src="@/assets/images/icon/menu.svg" alt="">
          </div>
        </div>
      </div>

    </nav>

    <!-- gnb   -->
    <div class="gnb"
         :class="isClicked ? 'clicked' : false"
    >

      <!-- gnb-top     -->
      <div class="blex-between flex-no-wrap w-full px-16 lg:hidden flex h-50 gnb-top">
        <logo/>
        <div class="blex"
             @click="isClicked = false">
          <img src="@/assets/images/icon/close.svg" alt="">
        </div>
      </div>

      <!-- gnb-bottom     -->
      <ul class="gnb-bottom">
        <li class="hidden">
          <a target="_blank" href="https://market.metarising.io" class="text-white font-semiBold text-xl">NFT
            Marketplace</a>
        </li>
        <li class="hidden">
          <a target="_blank" href="https://market.metarising.io/map" class="text-white font-semiBold text-xl">Land
            Map</a>
        </li>
        <li>
          <a target="_blank" href="https://seed-box.io" class="text-white font-semiBold text-xl">SeedBox</a>
        </li>
        <li class="hidden">
          <a target="_blank" href="https://market.metarising.io/swap" class="text-white font-semiBold text-xl">Swap</a>
        </li>
        <li>
          <a target="_blank" href="https://bridge.microtuber.io" class="text-white font-semiBold text-xl">Bridge</a>
        </li>
        <li>
          <a target="_blank" href="https://metarising.gitbook.io/metarising-en-litepaper-version-1.0/"
             class="text-white font-semiBold text-xl"
             v-if="currentLang === 'en'"
          >Docs</a>
          <a target="_blank" href="https://metarising.gitbook.io/metarising-kr-litepaper-version-1.0/"
             class="text-white font-semiBold text-xl"
             v-else
          >Docs</a>
        </li>
        <!--        <li>-->
        <!--          <a tartget="_blank" href="#" class="text-white font-semiBold text-xl">Docs</a>-->
        <!--          <ul>-->
        <!--            <li class="blex-left pl-16 pt-16">-->
        <!--              <a target="_blank" href="https://metarising.gitbook.io/metarising-en-litepaper-version-1.0/"-->
        <!--                 class="text-white font-medium text-normal w-full pb-10">Git Book</a>-->
        <!--            </li>-->
        <!--          </ul>-->
        <!--        </li>-->
      </ul>


    </div>
  </header>
</template>

<script>
import Logo from '../../components/logo/Logo'

export default {
  name: 'TheNav',
  data: () => ({
    isActive: false,
    isClicked: false
  }),
  components: {
    Logo
  },
  methods: {
    mouseover () {
      this.isActive = true
    },
    mouseout () {
      this.isActive = false
    }
  },
  computed: {
    currentLang: {
      get () {
        return this.$i18n.locale
      },
      set (val) {
        this.$i18n.locale = val
        this.$nextTick(() => {
          if (this.$scrollTrigger) {
            this.$scrollTrigger.refresh()
          }
        })
      }
    }
  },
  mounted () {
    // if (this.$scrollTrigger) {
    //   this.$scrollTrigger.refresh()
    // }
  }
}
</script>

<style scoped lang="scss">
header::v-deep {
  //overflow: hidden;
  //
  //&.active {
  //  overflow: visible;
  //}

  &.nav__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background-color: rgba(0, 0, 0, .8);
    backdrop-filter: blur(6px);
    z-index: 100000;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    transition: all .5s;

    @media screen and (max-width: 1024px) {
      height: 50px;
    }

    &.active {
      top: -100%;
      transition: all .5s;
    }


    nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      min-height: 80px;
      justify-content: space-between;
      max-width: 1280px;

      @media screen and (max-width: 1024px) {
        min-height: 50px;
      }

      .logo {
        padding-right: 3.125vw;
        @media screen and (max-width: 1024px) {
          padding-right: 0;
        }
      }

      .list-wrapper {
        display: flex;
        flex-wrap: nowrap;

        .item {
          position: relative;
          margin-right: 3.125vw;
          padding-bottom: 4px;
          font-size: 20px;
          font-weight: 400;
          cursor: pointer;
          color: #fff;

          .arrow-down {
            transition: all .2s;
            display: flex;
            width: 100%;
            justify-content: center;
            align-items: center;
            margin-left: 4px;
          }

          a {
            color: #fff;
          }

          &:hover {

            .arrow-down {
              transform: rotate(180deg);
              transition: all .2s;
            }

            &::after {
              content: '';
              position: absolute;
              bottom: -10%;
              left: 0;
              width: 100%;
              height: 1px;
              background: linear-gradient(to right, #000000, #ffffff, #000000);
              animation: hover .2s linear forwards;
            }

          }
        }
      }

      @keyframes hover {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      .sub-menu {
        position: absolute;
        visibility: hidden;
        width: 100%;
        white-space: nowrap;
        font-size: 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-top: 28px;
        mix-blend-mode: difference;

        &.on {
          visibility: visible;
          animation: sub .2s linear forwards;
        }
      }

      @keyframes sub {
        0% {
          transform: translateY(-15%);
        }
        100% {
          transform: translateY(0);
        }
      }

      .lang {

        display: flex;
        flex-wrap: wrap;
        align-items: center;


        .line {
          width: 1px;
          height: 10px;
          background-color: #fff;
          margin: 0 12px;
        }

        .lang-list {
          font-size: 16px;
          font-weight: 600;
          color: rgba(255, 255, 255, .5);
          position: relative;

          &:hover {
            cursor: pointer;
            color: rgba(255, 255, 255, 1);
            transition: all .2s;

            &::after {
              content: '';
              position: absolute;
              bottom: -10%;
              left: 0;
              width: 100%;
              height: 1px;
              background: linear-gradient(to right, #000000, #ffffff, #000000);
              animation: hover .2s linear forwards;
            }
          }

          &.clicked {
            color: rgba(255, 255, 255, 1);

            &::after {
              content: '';
              position: absolute;
              bottom: -10%;
              left: 0;
              width: 100%;
              height: 1px;
              background: linear-gradient(to right, #000000, #ffffff, #000000);
            }
          }

        }

      }
    }

    .gnb {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: none;
      width: 100%;
      height: 0;
      background-color: #000;

      &.clicked {
        display: block;
        animation: topToBottom .2s linear forwards;
      }

      @keyframes topToBottom {
        0% {
          height: 0;
        }
        100% {
          height: 100vh;
        }
      }

      .gnb-top {
        min-height: 50px;
      }

      .gnb-bottom {
        width: 100%;
        height: 100%;
        padding: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: start;
        align-content: start;

        li {
          width: 100%;
          padding: 20px 0;
          opacity: 0;
          animation: BottomToTop .2s .3s linear forwards;
        }
      }

      @keyframes BottomToTop {
        0% {
          transform: translateY(20%);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }

    }


  }


}
</style>
